import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_CHALLENGES_KEY } from '_api/queries';
import { GET_MY_LIBRARY_CHALLENGES_KEY } from '_api/queries/challenge/useGetMyLibraryChallenges';
import { Challenge, ChallengePayload } from '_api/types';

export const CREATE_CHALLENGE = 'create-challenge';

export const useCreateChallenge = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Challenge, ChallengePayload>(
    () => '/challenge/create',
    'post',
    {},
    {
      mutationKey: [CREATE_CHALLENGE],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_CHALLENGES_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_MY_LIBRARY_CHALLENGES_KEY] });
      },
    },
    (body: ChallengePayload) => JSON.stringify(body),
  );
};
